module.exports = __webpack_public_path__ + "img/user-check-icon.7cfa3158.svg";